<template>
    <div class="medical-shop-page">
        <main class="main-container">
            <!-- banner -->
            <div class="banner">
                <img :src=imgurl alt="banner" />
            </div>

            <!-- 筛选栏 -->
            <div class="filter-bar">
                <div class="sort">
                    <span>Sort：</span>
                    <button :class="{ active: sortIndex == 99 }" @click="sortFecth(99)">
                        All
                    </button>
                    <button v-for="(item, index) in sortOptions" :key="index" :class="{ active: index == sortIndex }"
                        @click="sortFecth(item, index)">
                        {{ item.goodClassifyName }}
                    </button>
                </div>


            </div>

            <!-- 商品列表 -->
            <div class="goods-grid" v-loading="goodsLoading">
                <div class="goods-card" v-for="(item, idx) in goodsList" :key="item.goodId">
                    <div class="goods-img">
                        <img :src="item.goodCover" :alt="item.goodName"
                            @error="(e) => e.target.src = 'https://via.placeholder.com/180x180?text=No Image'" />
                        <span v-if="item.goodLabel" class="tag" :class="getTagClass(item.goodLabel)">{{ item.goodLabel
                            }}</span>
                    </div>
                    <div class="goods-info">
                        <h3 class="goods-name">{{ item.goodName }}</h3>
                        <div class="price">
                            <span class="now">${{ item.goodPrice }}</span>
                        </div>
                        <button class="add-cart" @click="cartFetch(item)">Product Details</button>
                    </div>
                </div>
                <!-- 空数据提示 -->
                <div class="empty-tip" v-if="!goodsLoading && goodsList.length === 0">
                    No products found
                </div>
            </div>

            <!-- Element 分页组件 -->
            <div class="pagination-wrapper">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pageNo" :page-sizes="[6, 10, 20, 30]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="goodsTotal" background>
                    <template slot="prev">Prev</template>
                    <template slot="next">Next</template>
                    <template slot="jumper">
                        <span class="el-pagination__jump-text">Go to</span>
                        <input class="el-input__inner" type="number" min="1" />
                        <span class="el-pagination__jump-text">Page</span>
                    </template>
                    <template slot="total">
                        <span class="el-pagination__total">Total {{ goodsTotal }} items</span>
                    </template>
                </el-pagination>
            </div>
        </main>
    </div>
</template>

<script>
import { goodsCommonGet, goodsClassifyGood } from '@/api/common'

export default {
    name: 'MedicalShop',
    data() {
        return {
            goodsList: [],
            goodsTotal: 0,
            goodsLoading: false,
            pageNo: 1,
            pageSize: 20,
            sortIndex: 99,
            // 排序选项（修复循环6个All的问题）
            sortOptions: [],
            sortStr: '',
            imgurl:'https://oss-cdn.anbio.com/uploads/de03d9961d5122d4464585e3c978f93f.png'
        }
    },
    mounted() {
        const goodClassifyId= this.$route.query.goodClassifyId;
        this.sortStr = goodClassifyId
       this.sortIndex = goodClassifyId-1;
        this.getGoodsList()
        this.goodsClassifyGoodFecth()

    },
    methods: {
        getGoodsList() {
            this.goodsLoading = true
          console.log(this.sortStr);
            if(this.sortStr==1)
            {
              console.log("12122343456");
              this.imgurl='https://oss-cdn.anbio.com/uploads/d3ffb5a02ee9e7e8a996176e946509a5.png';
            }
            else if(this.sortStr==2)
            {
              this.imgurl='https://oss-cdn.anbio.com/uploads/8905e73951c3a0e71042c8d984a663b2.png';
            }
            else if(this.sortStr==3)
            {
              this.imgurl='https://oss-cdn.anbio.com/uploads/6148219e675e2fff5345f049b0f10da0.png';
            }
            else if(this.sortStr==4)
            {
              this.imgurl='https://oss-cdn.anbio.com/uploads/be48f1f1ba2b55bc24999d5002a5cc4a.png';
            }
            else
            {
              this.imgurl='https://oss-cdn.anbio.com/uploads/de03d9961d5122d4464585e3c978f93f.png';
            }
            const params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                goodClassifyId: this.sortStr,
            }
            goodsCommonGet(params)
                .then(res => {
                    if (res.errorCode === null) {
                        const formatGoods = res.resultData.goodList.map(item => ({
                            ...item,
                            goodOriginalPrice: item.goodOriginalPrice ? item.goodOriginalPrice / 100 : 0,
                            goodPrice: item.goodPrice ? item.goodPrice / 100 : 0
                        }))
                        this.goodsList = formatGoods
                        this.goodsTotal = res.resultData.totalNum
                    }
                })
                .catch(err => {
                    console.error('请求失败', err)
                    this.$message.error('Failed to load products')
                })
                .finally(() => {
                    this.goodsLoading = false
                })
        },
        //---------------------
        goodsClassifyGoodFecth() {
            let params = {}

            goodsClassifyGood(params).then(res => {
                if (res.errorCode == null) {
                    this.sortOptions = res.resultData
                }
            })
        },


        sortFecth(item, index) {


            if (item == 99) {
                this.sortStr = ''
                this.sortIndex = 99
            } else {
                this.sortStr = item.goodClassifyId
                this.sortIndex = index
            }
            this.pageNo = 1
            this.getGoodsList()
        },

        handleSizeChange(val) {
            this.pageSize = val
            this.pageNo = 1
            this.getGoodsList()
        },

        handleCurrentChange(val) {
            this.pageNo = val
            this.getGoodsList()
            window.scrollTo({ top: 0, behavior: 'smooth' })
        },

        cartFetch(item) {
            this.$router.push({ path: '/buy', query: { id: item.goodId } })
        },

        getTagClass(label) {
            const tagMap = { Hot: 'red', Special: 'blue', Premium: 'green', New: 'orange' }
            return tagMap[label] || 'blue'
        }
    }
}
</script>

<style lang="less" scoped>
@blue: #1677ff;
@green: #36d399;
@gray-bg: #f5f7fa;
@shadow: 0 2px 12px rgba(22, 119, 255, 0.1);
@red: #f5222d;
@orange: #fa8c16;

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

/* 全局禁止横向滚动 */
body {
    overflow-x: hidden;
}

.medical-shop-page {
    width: 100%;
    min-height: 100vh;
    background: @gray-bg;
    overflow-x: hidden;
}

.main-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 15px 10px 30px;
    width: 100%;
    box-sizing: border-box;
}

.banner {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: @shadow;
    margin-bottom: 20px;

    img {
        width: 100%;
        height: 300px;
        object-fit: cover;
        display: block;
    }
}

.filter-bar {
    background: #fff;
    border-radius: 12px;
    padding: 12px;
    display: flex;
    align-items: center;
    box-shadow: @shadow;
    margin-bottom: 20px;
    width: 100%;
    box-sizing: border-box;

    .sort {
        display: flex;
        align-items: center;
        gap: 6px;
        flex-wrap: wrap;
        /* 自动换行，适配手机 */
        width: 100%;
        font-size: 15px;

        span {
            color: #666;
            white-space: nowrap;
        }

        button {
            padding: 5px 20px;
            border-radius: 16px;
            border: none;
            background: transparent;
            cursor: pointer;
            font-size: 13px;
            white-space: nowrap;
            background: #f2f3f5;

            &.active {
                background: @blue;
                color: #fff;
            }
        }
    }
}

.goods-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    margin-bottom: 30px;
    width: 100%;

    .empty-tip {
        grid-column: 1 / -1;
        text-align: center;
        padding: 40px 0;
        color: #999;
        font-size: 14px;
    }

    @media (min-width: 768px) {
        grid-template-columns: repeat(3, 1fr);
    }

    @media (min-width: 1024px) {
        grid-template-columns: repeat(4, 1fr);
    }

    .goods-card {
        background: #fff;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: @shadow;
        transition: 0.3s;

        &:hover {
            transform: translateY(-4px);
        }

        .goods-img {
            position: relative;

            img {
                width: 100%;
                height: 180px;
                object-fit: contain;
            }

            .tag {
                position: absolute;
                top: 8px;
                left: 8px;
                font-size: 10px;
                color: #fff;
                padding: 2px 6px;
                border-radius: 4px;

                &.green {
                    background: @green;
                }

                &.red {
                    background: @red;
                }

                &.blue {
                    background: @blue;
                }

                &.orange {
                    background: @orange;
                }
            }
        }

        .goods-info {
            padding: 12px;

            .goods-name {
                font-size: 14px;
                height: 40px;
                font-weight: bold;
                line-height: 1.4;
                overflow: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                margin-bottom: 8px;
            }

            .price {
                margin-bottom: 10px;

                .now {
                    color: @blue;
                    font-size: 16px;
                    font-weight: bold;
                }
            }

            .add-cart {
                width: 100%;
                height: 32px;
                background: @blue;
                color: #fff;
                border: none;
                border-radius: 6px;
                cursor: pointer;

                &:hover {
                    background: #0d63d8;
                }
            }
        }
    }
}

// ===================== 移动端分页修复（核心） =====================
.pagination-wrapper {
    width: 100%;
    padding: 10px 0;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    /* 手机居中，平板/电脑靠右 */
}

/* 手机端分页简化 + 不超出屏幕 */
@media (max-width: 767px) {
    ::v-deep .el-pagination {
        width: 100% !important;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 6px;
        padding: 0 5px;
        box-sizing: border-box;
    }

    ::v-deep .el-pagination__total,
    ::v-deep .el-pagination__sizes,
    ::v-deep .el-pagination__jump {
        display: none !important;
        /* 手机隐藏占位置的元素 */
    }

    ::v-deep .btn-prev,
    ::v-deep .btn-next,
    ::v-deep .el-pager li {
        margin: 0 !important;
        padding: 0 8px !important;
        font-size: 13px !important;
    }
}

/* 平板/电脑正常靠右 */
@media (min-width: 768px) {
    .pagination-wrapper {
        justify-content: flex-end;
    }
}

// =================================================================

::v-deep .el-pagination {
    --el-pagination-text-color: #666;
    --el-pagination-button-color: @blue;
}
</style>
